export const currencyFormatter = (value: number) => {
    const commaSeperator = value.toLocaleString('en-IN', {
        maximumFractionDigits: 0,
        style: 'currency',
        currency: 'INR'
    });
    return `${commaSeperator} /-`
}